import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home'
import RequestInviteModal from '@/components/Home/RequestInviteModal'
import TrackReferrals from '@/components/Home/TrackReferrals'
import Blog from '@/components/Blog/Blog'
import Careers from '@/components/Careers/Careers'

Vue.use(Router)

export default new Router({
  mode: 'history',
  linkActiveClass: 'active',
  transitionOnLoad: true,
  props: true,
  routes: [
    {
      path: '/blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/careers',
      name: 'Careers',
      component: Careers
    },
    {
      path: '*',
      name: 'Home',
      component: Home,
      children: [
        {
          path: 'request',
          component: RequestInviteModal
        },
        {
          path: 'track/:code?',
          component: TrackReferrals
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js